import { useMutation, useQueryClient } from '@tanstack/react-query';
import { counterpartyService } from '@/services/counterparty/counterparty-service';
import { counterpartyKeys } from '@/services/query-keys/counterparty-keys';
import { tradesKeys } from '@/services/query-keys/trades-keys';

interface UpdateCounterpartyVariables {
  id: number;
  data: Record<string, unknown>;
}

export const useUpdateCounterparty = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: UpdateCounterpartyVariables) => counterpartyService.updateAgreement(id, data),
    onSuccess: (_res, { id }) => {
      queryClient.invalidateQueries({ queryKey: counterpartyKeys.lists() });
      queryClient.invalidateQueries({ queryKey: counterpartyKeys.detail(id) });
      queryClient.invalidateQueries({ queryKey: tradesKeys.counterparties() });
    },
  });
};
